<template>
    <div class="overlay">
        <div class="overlay_inner warrning">
            <p class="note">{{ message }}</p>
            <p class="buttons">
              <a class="btn btn_deleteconfirm" @click.stop.prevent="emitAction(true)">{{ yesText }}</a>
              <a class="btn btn_darkblue" @click.stop.prevent="emitAction(false)">{{ noText }}</a>
            </p>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Popup",
		props: {
			popupType: {
				type: String,
				default: 'delete'
			},
			popupAction: {
				type: String,
				default: 'delete'
			},
      popupMessage: {
          type: String,
          default: ''
      }
		},
    data() {
      return {
        shown: false,
      }
    },
    updated() {
      if(!this.shown){
        window.addEventListener('keyup', this.keyHandler)
      }else{
        window.removeEventListener('keyup', this.keyHandler)
      }
      this.shown = !this.shown;
    },
    computed: {
			message() {
                if (this.popupMessage) {
                    return this.$gettext(this.popupMessage);
                }
				if (this.popupType === 'delete') {
					return this.$gettext('Opravdu si přejete tuto položku smazat?')
				}
				if (this.popupType === 'delete-multi') {
					return this.$gettext('Opravdu si přejete vybrané položky smazat?')
                }
				if (this.popupType === 'delete-image') {
					return this.$gettext('Opravdu si přejete obrázek smazat?')
				}
			},
			yesText() {
				if (this.popupType === 'delete') {
					return this.$gettext('Ano, Smazat')
				}
				if (this.popupType === 'delete-multi') {
					return this.$gettext('Ano, Smazat')
				}
				if (this.popupType === 'delete-image') {
					return this.$gettext('Ano, Smazat')
				}
                return this.$gettext('Ano');
			},
			noText() {
				if (this.popupType === 'delete') {
					return this.$gettext('Ne, položku zachovat')
				}
				if (this.popupType === 'delete-multi') {
					return this.$gettext('Ne, položky zachovat')
				}
				if (this.popupType === 'delete-image') {
					return this.$gettext('Ne, obrázek zachovat')
				}
                return this.$gettext('Ne');
			}
		},
		methods: {
			emitAction(actionValue) {
				this.$emit('popup-action', actionValue)
			},
      keyHandler(e){
        if(e.which === 13){
          this.emitAction(true);
        }else if(e.which === 27){
          this.emitAction(false);
        }
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/Popup.vue